module.exports = __webpack_public_path__ + "img/dashboard-play-btn.88f38f92.svg";